import { render } from "./vertical-align-top.vue?vue&type=template&id=34720aed"
import script from "./vertical-align-top.vue?vue&type=script&lang=js"
export * from "./vertical-align-top.vue?vue&type=script&lang=js"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_all\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__